import { render, staticRenderFns } from "./EditTrackingListTemplate.vue?vue&type=template&id=ba2234a4&scoped=true"
import script from "./EditTrackingListTemplate.vue?vue&type=script&lang=js"
export * from "./EditTrackingListTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditTrackingListTemplate.vue?vue&type=style&index=0&id=ba2234a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2234a4",
  null
  
)

export default component.exports